const SatInvoicesTable = () => import('@/components/satVault/Invoices.vue')
const SatInvoicesRelationTable = () => import('@/components/satVault/InvoicesRelations.vue')
const SatLoadInvoices = () => import('@/components/satVault/LoadInvoices.vue')
const SatRecurringInvoiceLoad = () => import('@/components/satVault/RecurringInvoiceLoad.vue')
const SatLoadHistory = () => import('@/components/satVault/LoadHistory.vue')
const SatReportProvider = () => import('@/components/satVault/ReportProvider.vue')

const satVaultPermissions = [
  'descarga_cfdis',
  'descarga_automatizada',
  'cfdi_relacionados',
  'cfdi_descargados',
  'historial_descargas',
  'reporte_proveedores',
]

export const satVaultRoutes = [
  {
    path: '/sat-vault',
    meta: { breadcrumb: 'Bóveda SAT', requiresAuth: true, permissions: satVaultPermissions},
    children: [
      { path: 'download', component: SatLoadInvoices, meta: { breadcrumb: 'Descarga de CFDIs', permissions: [satVaultPermissions[0]] } },
      { path: 'invoices', component: SatInvoicesTable, meta: { breadcrumb: 'CFDIs Descargados', permissions: [satVaultPermissions[2]] } },
      { path: 'invoices-relations', component: SatInvoicesRelationTable, meta: { breadcrumb: 'CFDIs Relacionados', permissions: [satVaultPermissions[3]] } },
      { path: 'automatic-download', component: SatRecurringInvoiceLoad, meta: { breadcrumb: 'Descarga Automatizada',permissions: [satVaultPermissions[1]] } },
      { path: 'download-history',  component: SatLoadHistory, meta: { breadcrumb: 'Historial Descargas', permissions: [satVaultPermissions[4]] } },
      { path: 'report-provider',  component: SatReportProvider, meta: { breadcrumb: 'Reporte Proveedores', permissions: [satVaultPermissions[5]] } },
    ],
  },
]
